import { pickBy } from "lodash";

// Role codes
export const ROLES = {
  ADMIN: "YWRtaW4=", // admin (base64 encoded)
  CLIENT: "Y2xpZW50", // client (base64 encoded)
  CONTRACTOR: "Y29udHJhY3Rvcg==", // contractor (base64 encoded)
  EMPLOYEE: "ZW1wbG95ZWU=", // employee (base64 encoded)
};

// Menu access permissions by role
export const MENU_PERMISSIONS = {
  // All sidebar menu items
  PROJECTS: [ROLES.ADMIN, ROLES.CLIENT, ROLES.CONTRACTOR, ROLES.EMPLOYEE],
  CLIENTS: [ROLES.ADMIN],
  USER_MANAGEMENT: [ROLES.ADMIN],
  TIME_ENTRY: [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.CONTRACTOR],
  REPORTS: [ROLES.ADMIN],
  EMAIL: [ROLES.ADMIN],
  // Report submenu items
  ALL_TIME_ENTRIES: [
    ROLES.ADMIN,
    ROLES.CLIENT,
    ROLES.EMPLOYEE,
    ROLES.CONTRACTOR,
  ],
  PROJECT_TRACKING: [ROLES.ADMIN],
};

// Helper function to check if a user has permission to access a menu item
export const hasMenuPermission = (
  userRole: string | undefined,
  menuPermission: string[]
): boolean => {
  if (!userRole) return false;
  return menuPermission.includes(userRole);
};

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const removeEmptyProps = (obj) => {
  // return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
  return pickBy(
    obj,
    (value) => value !== null && value !== undefined && value !== ""
  );
};
